import { render, staticRenderFns } from "./PreLoader.vue?vue&type=template&id=8a05d098&scoped=true&"
import script from "./PreLoader.vue?vue&type=script&lang=js&"
export * from "./PreLoader.vue?vue&type=script&lang=js&"
import style0 from "./PreLoader.vue?vue&type=style&index=0&id=8a05d098&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a05d098",
  null
  
)

export default component.exports